import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ChargeCreditCardResponse,
  ChargeCreditCard: (params: vp.ChargeCreditCardRequest) => void,
  reset: () => void,
  ChargeCreditCardAsync: (params: vp.ChargeCreditCardRequest) => Promise<vp.ChargeCreditCardResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostChargeCreditCard: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldChargeCreditCard, setShouldChargeCreditCard] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.ChargeCreditCardRequest>({
    PortalUser: '',
    Amount: 0,
    Currency: '',
    Country: '',
    CreditCardToken: '',
    IdempotencyKey: '',
    ClientAccountID: '',
  });
  const [response, setResponse] = useState<vp.ChargeCreditCardResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldChargeCreditCard) return () => {};

    const PostChargeCreditCard = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postChargeCreditCard(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldChargeCreditCard) void PostChargeCreditCard();
    setShouldChargeCreditCard(false);
    return () => {
      source.cancel();
    };
  }, [shouldChargeCreditCard]);

  return [
    response,
    (_params: vp.ChargeCreditCardRequest) => {
      setParams(_params);
      setShouldChargeCreditCard(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldChargeCreditCard(false);
    },
    async (_params: vp.ChargeCreditCardRequest) => {
      const res = await api.postChargeCreditCard(_params, source);
      return res;
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostChargeCreditCard);
